<script>
  import Translate from "../locale.svelte";
  import { placePath } from "../../support/links";
  import { isEmpty } from "lodash-es";
  import { getNow } from "../../data/clock";
  import { getStatusNote } from "../../domain/status";

  export let time = getNow();
  export let title = "";
  export let entries = [];
  export let showTitle = true;
  export let showSubtitle = false;
  export let muted = false;

  $: showTable = isEmpty(entries) == false;
</script>

{#if showTable}
  <table class="Status" class:muted>
    <thead class:hide={!showTitle}>
      <tr>
        <th>
          <Translate label={title} />
        </th>
      </tr>
    </thead>

    <tbody>
      {#each entries as entry}
        <tr>
          <td class="StatusLabelColumn">
            <a class="ItemTitle" href={placePath(entry)}>
              {entry.title}
              {#if entry.parentTitle && showSubtitle}
                <span class="ItemSubtitle type-caption">{entry.parentTitle}</span>
              {/if}
              {#if getStatusNote(entry, $time)}
                <i class="ItemSubtitle type-caption">{getStatusNote(entry, $time)}</i>
              {/if}
            </a>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{/if}

<style>
  .Status {
    border-collapse: collapse;
    width: 100%;
  }

  .Status:not(:first-child) {
    margin-top: 28px;
  }

  .Status.muted th {
    opacity: 0.8;
  }

  .Status.muted td {
    opacity: 0.6;
  }

  .Status th {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.05em;
    line-height: 1;
    padding: 8px 16px 12px 22px;
    text-align: left;
    text-transform: uppercase;
  }

  .Status td {
    vertical-align: baseline;
  }

  .hide {
    position: absolute;
    clip: rect(0, 0, 0, 0);
  }

  .StatusLabelColumn {
    padding: 4px 0 4px 22px;
  }

  .ItemTitle {
    display: block;
    line-height: 1;
    padding: 8px 8px 8px 0;
    text-decoration: none;
  }

  .ItemSubtitle {
    display: block;
    margin-top: 4px;
  }
</style>
